import request from '@/utils/request'


// 查询赛事单名称列表
export function listCompetition(query) {
  return request({
    url: '/platform/competition-form/list',
    method: 'get',
    params: query
  })
}

// 查询赛事单名称分页
export function pageCompetition(query) {
  return request({
    url: '/platform/competition-form/page',
    method: 'get',
    params: query
  })
}

// 查询赛事单名称详细
export function getCompetition(data) {
  return request({
    url: '/platform/competition-form/detail',
    method: 'get',
    params: data
  })
}

// 新增赛事单名称
export function addCompetition(data) {
  return request({
    url: '/platform/competition-form/add',
    method: 'post',
    data: data
  })
}

// 修改赛事单名称
export function updateCompetition(data) {
  return request({
    url: '/platform/competition-form/edit',
    method: 'post',
    data: data
  })
}

// 删除赛事单名称
export function delCompetition(data) {
  return request({
    url: '/platform/competition-form/delete',
    method: 'post',
    data: data
  })
}
